//#region src/core/ui/container/core.ts
/** @internal */
var ContainerCore = class {
	#media = null;
	setMedia(media) {
		this.#media = media;
	}
	getState() {
		return { controlsVisible: this.#media.controlsVisible };
	}
};
//#endregion
export { ContainerCore };

//# sourceMappingURL=core.js.map